import React from 'react';
import styles from './Container.module.css';

interface IContainer {
  children: React.ReactNode;
  fluid?: boolean;
  relative?: boolean;
  content?: boolean;
}

export default function Container({
  children,
  fluid = false,
  relative = false,
  content = false,
}: IContainer) {
  return (
    <div
      className={`${styles.container} ${fluid ? styles.container_fluid : ''} ${
        relative ? styles.pr : ''
      } ${content ? styles.container_content : ''} `}
    >
      {children}
    </div>
  );
}
